module.exports = __webpack_public_path__ + "img/teacherIcon4.67e90800.jpg";